import { inject} from '@angular/core';
import { CanActivateFn } from '@angular/router';
import Keycloak from 'keycloak-js';
import { AuthService } from '../services/auth/auth.service';

export const authGuard: CanActivateFn = async () => {
  const keycloak = inject(Keycloak);
  const authService = inject(AuthService);

  // Online: normaler Keycloak-Check
  if(keycloak.authenticated) return true;

  //Offline: gecachte Session vorhanden?
  if(authService.isOffline() && authService.loggedIn()) return true;

  // Kein Zugang -> Login
  await keycloak.login({ redirectUri: window.location.href});
  return false;
};
